export default __webpack_public_path__ + "static/media/stomach_plot_male.0fe35299.png";